/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconPlayLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 12 12">
    <g>
    <path d="M1.8,11.7c-0.1,0-0.3,0-0.4-0.1C1.1,11.4,1,11.2,1,10.9V1.1c0-0.3,0.1-0.5,0.4-0.6c0.2-0.1,0.5-0.1,0.8,0l8.5,4.9 C10.9,5.5,11,5.7,11,6s-0.1,0.5-0.4,0.6l-8.5,4.9C2,11.6,1.9,11.7,1.8,11.7z M2.5,2.4v7.2L8.8,6L2.5,2.4z" />
</g>
  </Icon>
);
};

IconPlayLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEyIDEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxnPgogICAgPHBhdGggZD0iTTEuOCwxMS43Yy0wLjEsMC0wLjMsMC0wLjQtMC4xQzEuMSwxMS40LDEsMTEuMiwxLDEwLjlWMS4xYzAtMC4zLDAuMS0wLjUsMC40LTAuNmMwLjItMC4xLDAuNS0wLjEsMC44LDBsOC41LDQuOSBDMTAuOSw1LjUsMTEsNS43LDExLDZzLTAuMSwwLjUtMC40LDAuNmwtOC41LDQuOUMyLDExLjYsMS45LDExLjcsMS44LDExLjd6IE0yLjUsMi40djcuMkw4LjgsNkwyLjUsMi40eiIvPgogIDwvZz4KPC9zdmc+";
IconPlayLineComponent.Content = `<svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
  <g>
    <path d="M1.8,11.7c-0.1,0-0.3,0-0.4-0.1C1.1,11.4,1,11.2,1,10.9V1.1c0-0.3,0.1-0.5,0.4-0.6c0.2-0.1,0.5-0.1,0.8,0l8.5,4.9 C10.9,5.5,11,5.7,11,6s-0.1,0.5-0.4,0.6l-8.5,4.9C2,11.6,1.9,11.7,1.8,11.7z M2.5,2.4v7.2L8.8,6L2.5,2.4z"/>
  </g>
</svg>`;

const IconPlayLine = styled(IconPlayLineComponent)``;

export default IconPlayLine;
